
import PasswortVergessenLogic from "@/logic/passwort_vergessen_logic"
import Vue from "vue"
import Component from "vue-class-component"

@Component
export default class PasswortVergessen extends Vue {
  $refs!: {
    form: HTMLFormElement
  }

  logic?: PasswortVergessenLogic = null

  mounted() {
    this.logic = new PasswortVergessenLogic()
    this.logic.init()
  }

  passwortAnfordern() {
    var valid = this.$refs.form.validate()
    if (!valid) return

    this.logic.passwortAnfordern()
  }
}
